import Swal from "sweetalert2";
import {createApp} from "vue";
import PaymentDocumentCreationConfirmationModal from "../PaymentDocumentCreationConfirmationModal.vue";
import {apiRequestsHelper} from "@/state/pinia/apiRequestHelper";
import ScrollableCommonTable from "@/components/widgets/ScrollableCommonTable.vue";
import CommonTable2 from "@/components/widgets/CommonTable2.vue";
import PaymentConfirmationModal from "../PaymentConfirmationModal.vue";
import {log} from "@/state/pinia/log";
import {useLazyLoaderModule, usePaymentsManagerModule} from "@/state/pinia";

export const paymentsHelperMethods = {

    // =================== PAYMENTS DOCUMENTS OPERATIONS ===================
    showPaymentDocumentCreateConfirmModal(paymentsChecked) {
        const lazyLoaderModule = useLazyLoaderModule()
        lazyLoaderModule.setDisplayLazyLoader(true);
        lazyLoaderModule.setProgressBarMessage( "Ładowanie danych.");
        var documentsForCreateDocument = [];
        for (var i = 0; i < paymentsChecked.length; i++) {
            var documentId = paymentsChecked[i]["id_dokumentu"];
            var documentNumber = paymentsChecked[i]["numer_dokumentu"];
            var drugstoreId = paymentsChecked[i]["id_apteki"];
            var supplierId = paymentsChecked[i]["id_dostawcy"];
            var paymentAmount = paymentsChecked[i]["suma_platnosci"];

            var paymentDocumentRequest = {
                documentId: documentId,
                documentNumber: documentNumber,
                drugstoreId: drugstoreId,
                supplierId: supplierId,
                paymentAmount: paymentAmount
            }

            documentsForCreateDocument.push(paymentDocumentRequest);

        }

        lazyLoaderModule.setDisplayLazyLoader(false);
        return paymentsHelperMethods.proceedWithDocumentCreation(documentsForCreateDocument, false);


    },

    proceedWithDocumentCreation(documentsForCreateDocument, reloadList) {
        return paymentsHelperMethods.fireDocumentCreateConfirmationModal(documentsForCreateDocument).then((proceed) => {
            if (proceed.value) {
                return paymentsHelperMethods.confirmCreatingPaymentDocument(documentsForCreateDocument);
            } else {
                return new Promise((resolve) => {
                    resolve({
                        isConfirmed: false,
                        reloadList: reloadList
                    });
                });
            }
        });
    },

    confirmCreatingPaymentDocument(documentsRequests) {
        const lazyLoaderModule = useLazyLoaderModule()
        const paymentsModule = usePaymentsManagerModule()
        var payload = {
            createDocumentRequests: documentsRequests,
            ignoreNotValidPayments: false
        }
        lazyLoaderModule.setDisplayLazyLoader(true);
        lazyLoaderModule.setProgressBarMessage( "Zapisywanie zmian w dokumencie");
        return paymentsModule.httpCreateDocuments(payload).then((response) => {
            if (response.status === 203) {

                var ignoredPaymentsTable = {
                    headers: [
                        {
                            text: "Numer dokumentu",
                            key: "documentNumber",
                            type: "text",
                            style: "width:20%",
                            class: "table-header-white",
                        },
                        {
                            text: "Uwagi",
                            key: "warningMessage",
                            type: "text",
                            style: "width:80%",
                            class: "table-header-white",
                        }
                    ],
                    data: response.data.payload.deniedRequests
                }
                return paymentsHelperMethods.fireIgnoreProceedWithDocumentCreationModal(ignoredPaymentsTable).then((proceed) => {
                    if (proceed.isConfirmed) {
                        lazyLoaderModule.setDisplayLazyLoader(true);
                        lazyLoaderModule.setProgressBarMessage( "Dodawanie dokumentu wypłaty");
                        var payload = {
                            createDocumentRequests: documentsRequests,
                            ignoreNotValidPayments: true
                        }
                        return paymentsModule.httpCreateDocuments(payload).then((response) => {
                            apiRequestsHelper.handleResponseWithDialogs(response, true);
                            return new Promise((resolve) => {
                                resolve({
                                    isConfirmed: false,
                                    reloadList: true,
                                    ...response
                                });
                            });


                        }).catch((error) => {
                            apiRequestsHelper.catchResponseError(error, "httpCreateDocuments");
                            return new Promise((resolve) => {
                                resolve({
                                    isConfirmed: false,
                                    reloadList: true,
                                    ...response
                                });
                            });
                        });


                    }
                });


            } else if (response.status === 200) {
                apiRequestsHelper.handleResponseWithDialogs(response, true);
                return new Promise((resolve) => {
                    resolve({
                        isConfirmed: true,
                        reloadList: true,
                        ...response
                    });
                });
            } else {
                apiRequestsHelper.handleResponseWithDialogs(response, true);
                return new Promise((resolve) => {
                    resolve({
                        isConfirmed: false,
                        reloadList: true,
                        ...response
                    });
                });
            }


        }).catch((error) => {
            apiRequestsHelper.catchResponseError(error, "httpCreateDocuments");
            return new Promise((resolve) => {
                resolve({
                    isConfirmed: false,
                    reloadList: true
                });
            });
        });
    },

    fireDocumentCreateConfirmationModal(documentsRequests) {
        return Swal.fire({
            title: "Potwierdzenie utworzenia dokumentów wypłaty",
            text: "Czy na pewno chcesz potwierdzić utworzenie dokumentów wypłaty?",
            html: '<div id="confirm-document-creation-modal"></div>',
            showCloseButton: true,
            showConfirmButton: true,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonText: 'Tak',
            // confirmButtonAriaLabel: "Thumbs up, great!",
            cancelButtonText: 'Nie',
            // cancelButtonAriaLabel: "Thumbs down",
            width: 900,
            didOpen: () => {
                // Dynamically mount the Vue.js component inside the SweetAlert2 content
                const app = createApp(PaymentDocumentCreationConfirmationModal, {
                    documentsRequests: documentsRequests,
                    showConfirmationButton: false
                });
                app.mount('#confirm-document-creation-modal');
            },
            willClose: () => {
                // Clean up the mounted Vue instance when the dialog is closed
                const componentContainer = document.getElementById('confirm-document-creation-modal');
                if (componentContainer) {
                    const appInstance = componentContainer.__vue_app__;
                    if (appInstance) {
                        appInstance.unmount(); // Unmount the component to prevent memory leaks
                    }
                }
            }
        })
    },

    fireIgnoreProceedWithDocumentCreationModal(ignoredPaymentsTable) {
        const lazyLoaderModule = useLazyLoaderModule()
        lazyLoaderModule.setDisplayLazyLoader(false);
        return Swal.fire({
            title: "Nie jest możliwe utworzenie wszystkich dokumentów wypłaty",
            text: "",
            html: '' +
                '<p>Na liscie dokumentów zakupu istanieją takie, na które nie można wystawić dokumentów wypłaty.</p>' +
                '<p>Czy zignorować te dokumenty i utworzyć wypłaty na pozostałe dokumenty?</p>' +
                '<p>Lista problematycznych dokumentów zakupu:</p>' +
                '<div id="ignore-and-proceed-document-creation-modal"></div>',
            showCloseButton: true,
            showConfirmButton: true,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonText: 'Zignoruj i wystaw dokumeny wypłat na pozostałe dokumenty',
            // confirmButtonAriaLabel: "Thumbs up, great!",
            cancelButtonText: 'Anuluj',
            // cancelButtonAriaLabel: "Thumbs down",
            width: 900,
            didOpen: () => {
                // Dynamically mount the Vue.js component inside the SweetAlert2 content
                const app = createApp(ScrollableCommonTable, {
                    table: ignoredPaymentsTable,
                    headerCheckboxClass: "table-header-white",

                });
                app.mount('#ignore-and-proceed-document-creation-modal');
            },
            willClose: () => {
                // Clean up the mounted Vue instance when the dialog is closed
                const componentContainer = document.getElementById('ignore-and-proceed-document-creation-modal');
                if (componentContainer) {
                    const appInstance = componentContainer.__vue_app__;
                    if (appInstance) {
                        appInstance.unmount(); // Unmount the component to prevent memory leaks
                    }
                }
            }
        })
    },
    // =================== PAYMENTS OPERATIONS ===================

    showPaymentConfirmModal(checkedPaymentsRows, rowIdentifierKey) {
        var paymentsRowsForSelectedDocumentsToPay = checkedPaymentsRows
        var documentIdDocumentNumberMap = {};
        for (var i = 0; i < paymentsRowsForSelectedDocumentsToPay.length; i++) {
            var documentId = paymentsRowsForSelectedDocumentsToPay[i]["id_dokumentu"];
            var documentNumber = paymentsRowsForSelectedDocumentsToPay[i]["numer_dokumentu"];
            if (documentIdDocumentNumberMap[documentId] === undefined) {
                documentIdDocumentNumberMap[documentId] = documentNumber;
            }
        }

        var paymentData = {
            paymentAmount: paymentsRowsForSelectedDocumentsToPay.map(row => row['wartosc_brutto']).reduce((a, b) => a + b, 0),
            paymentDocumentNumbers: documentIdDocumentNumberMap,
            documentIds: paymentsRowsForSelectedDocumentsToPay.map(row => row[rowIdentifierKey])
        }

        return paymentsHelperMethods.fireConfirmationModal(paymentData).then((proceed) => {
            if (proceed.value) {
                return paymentsHelperMethods.confirmPayment(paymentData, checkedPaymentsRows);
            } else {
                return new Promise((resolve) => {
                    resolve({
                        isConfirmed: false,
                        reloadList: false
                    });
                });
            }
        });


    },

    fireConfirmationModal(paymentData) {
        return Swal.fire({
            title: "Potwierdzenie płatności",
            text: "Czy na pewno chcesz potwierdzić płatność?",
            html: '<div id="confirm-payment-modal"></div>',
            showCloseButton: true,
            showConfirmButton: true,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonText: 'Tak',
            // confirmButtonAriaLabel: "Thumbs up, great!",
            cancelButtonText: 'Nie',
            // cancelButtonAriaLabel: "Thumbs down",
            width: 900,
            didOpen: () => {
                // Dynamically mount the Vue.js component inside the SweetAlert2 content
                const app = createApp(PaymentConfirmationModal, {
                    payment: paymentData,
                    showConfirmationButton: false
                });
                app.mount('#confirm-payment-modal');
            },
            willClose: () => {
                // Clean up the mounted Vue instance when the dialog is closed
                const componentContainer = document.getElementById('confirm-payment-modal');
                if (componentContainer) {
                    const appInstance = componentContainer.__vue_app__;
                    if (appInstance) {
                        appInstance.unmount(); // Unmount the component to prevent memory leaks
                    }
                }
            }
        })
    },

    confirmPayment(paymentData, selectedPaymentsRows) {
        const lazyLoaderModule = useLazyLoaderModule()
        const paymentsModule = usePaymentsManagerModule()
        lazyLoaderModule.setDisplayLazyLoader(true);
        lazyLoaderModule.setProgressBarMessage( "Oznaczanie dokumentów jako opłacone");
        var itemsToPay = [];
        for (var i = 0; i < selectedPaymentsRows.length; i++) {
            var selectedPayment = selectedPaymentsRows[i];

            var paymentDto = {
                guid: null,
                documentId: selectedPayment["id_dokumentu"],
                drugstoreId: selectedPayment["id_apteki"],
                supplierId: selectedPayment["id_dostawcy"],
                documentNumber: paymentData.paymentDocumentNumbers[selectedPayment["id_dokumentu"]],
                paymentAmount: selectedPayment['wartosc_brutto'],
                paymentDateTime: null,
                state: null,
                notifications: "",
                warningMessage: null

            }
            itemsToPay.push(paymentDto);
        }
        var payload = {
            documentsToPay: itemsToPay,
            ignoreNotValidPayments: false
        }

        return paymentsModule.httpPayForDocuments(payload).then((response) => {
            lazyLoaderModule.setDisplayLazyLoader(false);
            const paymentsModule = usePaymentsManagerModule()
            if (response.status === 203) {
                var ignoredPaymentsTable = {
                    headers: [
                        {
                            text: "Numer dokumentu",
                            key: "documentNumber",
                            type: "text",
                            style: "width:20%",
                            class: "table-header-white",
                        },
                        {
                            text: "Uwagi",
                            key: "warningMessage",
                            type: "text",
                            style: "width:80%",
                            class: "table-header-white",
                        }
                    ],
                    data: response.data.payload.filter(item => item.warningMessage != null && item.warningMessage.length > 0)
                }
                return paymentsHelperMethods.fireIgnoreProceedWithPaymentModal(ignoredPaymentsTable).then((proceed) => {
                    if (proceed.isConfirmed) {
                        var payload = {
                            documentsToPay: itemsToPay,
                            ignoreNotValidPayments: true
                        }
                        lazyLoaderModule.setDisplayLazyLoader(true);
                        return paymentsModule.httpPayForDocuments(payload).then((paymentsResponse) => {
                            log.log("Paying for documents response:", paymentsResponse);
                            if (paymentsResponse.status === 200) {
                                lazyLoaderModule.setDisplayLazyLoader(false);
                                return paymentsHelperMethods.runDocumentCreationModalAfterPaymentsDone(itemsToPay, paymentsResponse);
                            } else {
                                apiRequestsHelper.handleResponseWithDialogs(paymentsResponse, true);
                                return new Promise((resolve) => {
                                    resolve({
                                        isConfirmed: false,
                                        reloadList: true,
                                        ...paymentsResponse
                                    });
                                });
                            }


                        }).catch((error) => {
                            log.log("Error while paying documents:", error)
                            apiRequestsHelper.catchResponseError(error, "httpPayForDocuments");
                            return new Promise((resolve) => {
                                resolve({
                                    isConfirmed: false,
                                    reloadList: true
                                });
                            });
                        });


                    } else {
                        lazyLoaderModule.setDisplayLazyLoader(false);
                        return new Promise((resolve) => {
                            resolve({
                                isConfirmed: false,
                                reloadList: false
                            });
                        });
                    }
                });


            } else {

                if (response.status === 200) {
                    lazyLoaderModule.setDisplayLazyLoader(false);
                    return paymentsHelperMethods.runDocumentCreationModalAfterPaymentsDone(itemsToPay, response);
                } else {
                    apiRequestsHelper.handleResponseWithDialogs(response, true);
                    return new Promise((resolve) => {
                        resolve({
                            isConfirmed: false,
                            reloadList: true, // just in case
                            ...response
                        });
                    });
                }

            }

        }).catch((error) => {
            log.log("Error 2 while paying documents:", error)
            return apiRequestsHelper.catchResponseError(error, "httpPayForDocuments");
        });
    },

    runDocumentCreationModalAfterPaymentsDone(itemsToPay, paymentResponse) {
        return Swal.fire({
            title: "Pozycje oznaczone jako opłacone",
            text: "Czy chcesz wygenerować dokumenty wypłaty?",
            icon: "success",
            showCloseButton: true,
            showConfirmButton: true,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonText: 'Tak',
            cancelButtonText: 'Nie',
            width: 900,
        }).then((proceed) => {
            if (proceed.isConfirmed) {

                var documentsForCreateDocument = [];
                for (var i = 0; i < itemsToPay.length; i++) {
                    var documentId = itemsToPay[i]["documentId"];
                    var documentNumber = itemsToPay[i]["documentNumber"];
                    var drugstoreId = itemsToPay[i]["drugstoreId"];
                    var supplierId = itemsToPay[i]["supplierId"];
                    var paymentAmount = itemsToPay[i]["paymentAmount"];

                    var paymentDocumentRequest = {
                        documentId: documentId,
                        documentNumber: documentNumber,
                        drugstoreId: drugstoreId,
                        supplierId: supplierId,
                        paymentAmount: paymentAmount
                    }

                    documentsForCreateDocument.push(paymentDocumentRequest);

                }


                return paymentsHelperMethods.proceedWithDocumentCreation(documentsForCreateDocument, true);

            } else {
                apiRequestsHelper.handleResponseWithDialogs(paymentResponse, true);
                return new Promise((resolve) => {
                    resolve({
                        isConfirmed: false,
                        reloadList: true,
                        ...paymentResponse
                    });
                });
            }
        });

    },

    fireIgnoreProceedWithPaymentModal(ignoredPaymentsTable) {

        return Swal.fire({
            title: "Zanaleziono błędne płatności",
            text: "Czy zignorować błędne płatności i dodać wyłącznie prawidłowe?",
            html: '<div id="ignore-and-proceed-payment-modal"></div>',
            showCloseButton: true,
            showConfirmButton: true,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonText: 'Tak, chcę dodać tylko prawidłowe płatności',
            // confirmButtonAriaLabel: "Thumbs up, great!",
            cancelButtonText: 'Anuluj',
            // cancelButtonAriaLabel: "Thumbs down",
            width: 900,
            didOpen: () => {
                // Dynamically mount the Vue.js component inside the SweetAlert2 content
                const app = createApp(ScrollableCommonTable, {
                    table: ignoredPaymentsTable,
                    headerCheckboxClass: "table-header-white",
                });
                app.mount('#ignore-and-proceed-payment-modal');
            },
            willClose: () => {
                // Clean up the mounted Vue instance when the dialog is closed
                const componentContainer = document.getElementById('ignore-and-proceed-payment-modal');
                if (componentContainer) {
                    const appInstance = componentContainer.__vue_app__;
                    if (appInstance) {
                        appInstance.unmount(); // Unmount the component to prevent memory leaks
                    }
                }
            }
        })
    },

    // ====================

    showPaymentsModal(item, paymentsForItemsRowIdentifier) {
        const paymentsModule = usePaymentsManagerModule()
        var showPaymentsModalTitle = "Płatności dla dokumentu: " + item['numer_dokumentu'];

        var paymentsForItemsTableHeaders = [
            {
                text: "Data płatności",
                key: "data_platnosci",
                type: "date",

            },
            {
                text: "Godzina płatności",
                key: "godz_platnosci",
                type: "date",
            },
            {
                text: "Kwota",
                key: "kwota",
                type: "number",
            },
            {
                text: "Uwagi",
                key: "uwagi",
                type: "text",
                style: "width:30%",
            }
        ]

        var getPaymentsPayload = {
            documentId: item['id_dokumentu'],
            drugstoreId: item['id_apteki']
        }

        return paymentsModule.httpGetLocalAndCentralPaymentsForDocument(getPaymentsPayload).then((paymentsResponse) => {
            log.log(paymentsResponse);
            if (paymentsResponse.status === 200) {

                var paymentsListForItemTableData = {};
                paymentsListForItemTableData['headers'] = paymentsForItemsTableHeaders;

                var paymentsForItemRows = [];
                for (const paymentForItem of paymentsResponse.data.payload) {
                    var paymentDate = paymentsHelperMethods.formatDateToLocale(paymentForItem['data_platnosci']);
                    var paymentTime = paymentsHelperMethods.formatTime(paymentForItem['godz_platnosci']);
                    paymentsForItemRows.push({
                        data_platnosci: paymentDate,
                        godz_platnosci: paymentTime,
                        kwota: paymentForItem['kwota'],
                        uwagi: paymentForItem['uwagi']
                    });

                }
                paymentsListForItemTableData['data'] = paymentsForItemRows;
                Swal.fire({
                    title: showPaymentsModalTitle,
                    html: '<div id="payments-for-item-modal"></div>',
                    showCloseButton: true,
                    showConfirmButton: false,
                    showCancelButton: false,
                    focusConfirm: false,

                    width: 900,
                    didOpen: () => {
                        // Dynamically mount the Vue.js component inside the SweetAlert2 content
                        const app = createApp(CommonTable2, {
                            table: paymentsListForItemTableData,
                            rowIdentifier: paymentsForItemsRowIdentifier,
                            sortColumn: "data_platnosci",
                            sortDirection: "desc",
                        });
                        app.mount('#payments-for-item-modal');
                    },
                    willClose: () => {
                        // Clean up the mounted Vue instance when the dialog is closed
                        const componentContainer = document.getElementById('payments-for-item-modal');
                        if (componentContainer) {
                            const appInstance = componentContainer.__vue_app__;
                            if (appInstance) {
                                appInstance.unmount(); // Unmount the component to prevent memory leaks
                            }
                        }
                    }
                });


            } else {
                return apiRequestsHelper.handleResponseWithDialogs(paymentsResponse, true);
            }


        }).catch((error) => {
            return apiRequestsHelper.catchResponseError(error, "httpGetLocalAndCentralPaymentsForDocument");
        });


    },

    synchronisePayments() {
        const lazyLoaderModule = useLazyLoaderModule()
        const paymentsModule = usePaymentsManagerModule()
        lazyLoaderModule.setDisplayLazyLoader(true);
        lazyLoaderModule.setProgressBarMessage( "Pobieranie danych o płatnościach. Synchronizacja w trakcie");
        return paymentsModule.httpSynchronisePayments();
    },

    parseLocalRowIdentifier(rowIdentifier) {
        var parts = rowIdentifier.split("#");
        if (parts.length !== 2) {
            return null;
        }

        return {
            documentId: parts[0],
            drugstoreId: parts[1],
        };
    },
    formatDateToLocale(date) {
        if (date === null || date === undefined) {
            return null;
        }

        var dateObj = new Date(date);
        return dateObj.toLocaleDateString();
    },
    formatDatetimeToLocaleFormat(datetime) {
        if (datetime === null || datetime === undefined) {
            return null;
        }

        var dateObj = new Date(datetime);
        // format datetime to pattern dd.MM.yyyy HH:mm:ss
        return dateObj.toLocaleDateString() + " " + dateObj.toLocaleTimeString();

    },
    formatDateToISO(date) {
        if (date === null || date === undefined) {
            return null;
        }

        var dateObj = new Date(date);
        return dateObj.toISOString().split('T')[0];
    },


    formatTime(daySeconds) {
        // check if daySeconds match an array with hours, mins and seconds
        if (Array.isArray(daySeconds)) {
            var hoursVal = daySeconds[0];
            var minutesVal = daySeconds[1];
            var secondsVal = daySeconds[2];
            return hoursVal + ":" + minutesVal + ":" + secondsVal;
        }

        var hours = Math.floor(daySeconds / 3600);
        var minutes = Math.floor((daySeconds - (hours * 3600)) / 60);
        var seconds = daySeconds - (hours * 3600) - (minutes * 60);

        return hours + ":" + minutes + ":" + seconds;
    },

    numberToTextPLN(amount) {
        if (amount == null) {
            return null;
        }

        const units = ["", "jeden", "dwa", "trzy", "cztery", "pięć", "sześć", "siedem", "osiem", "dziewięć"];
        const teens = ["dziesięć", "jedenaście", "dwanaście", "trzynaście", "czternaście", "piętnaście", "szesnaście", "siedemnaście", "osiemnaście", "dziewiętnaście"];
        const tens = ["", "", "dwadzieścia", "trzydzieści", "czterdzieści", "pięćdziesiąt", "sześćdziesiąt", "siedemdziesiąt", "osiemdziesiąt", "dziewięćdziesiąt"];
        const hundreds = ["", "sto", "dwieście", "trzysta", "czterysta", "pięćset", "sześćset", "siedemset", "osiemset", "dziewięćset"];

        const zlCases = ["złoty", "złote", "złotych"];
        const grCases = ["grosz", "grosze", "groszy"];
        const thousandCases = ["tysiąc", "tysiące", "tysięcy"];
        const millionCases = ["milion", "miliony", "milionów"];

        // Helper function to handle cases (1, 2-4, 5-)
        function getCase(value, cases) {
            if (value === 1) return cases[0];
            if (value >= 2 && value <= 4) return cases[1];
            return cases[2];
        }

        // Function to convert three-digit number to text
        function convertHundreds(n) {
            const hundred = Math.floor(n / 100);
            const ten = Math.floor((n % 100) / 10);
            const unit = n % 10;

            if (ten === 1) return `${hundreds[hundred]} ${teens[unit]}`.trim();
            return `${hundreds[hundred]} ${tens[ten]} ${units[unit]}`.trim();
        }

        // Function to convert large numbers (thousands, millions)
        function convertLargeNumber(n, cases) {
            if (n === 0) return "";
            if (n === 1) return `jeden ${cases[0]}`;

            const result = convertHundreds(n);
            return `${result} ${getCase(n, cases)}`.trim();
        }

        // Split amount into złoty and grosz
        const zl = Math.floor(amount);  // Złoty
        const gr = Math.round((amount - zl) * 100);  // Grosze

        // Convert złoty part to text (handle millions, thousands, and hundreds)
        let zlText = "";
        const millions = Math.floor(zl / 1000000);
        const thousands = Math.floor((zl % 1000000) / 1000);
        const remainder = zl % 1000;

        if (millions > 0) {
            zlText += `${convertLargeNumber(millions, millionCases)} `;
        }
        if (thousands > 0) {
            zlText += `${convertLargeNumber(thousands, thousandCases)} `;
        }
        zlText += `${convertHundreds(remainder)} ${getCase(remainder, zlCases)}`.trim();

        // Convert grosz part to text
        let grText = "";
        if (gr === 0) {
            grText = "zero groszy";
        } else {
            grText = `${convertHundreds(gr)} ${getCase(gr, grCases)}`;
        }

        return `${zlText.trim()} i ${grText}`.trim();
    },

    ignoreAll(paymentsChecked) {

        if (paymentsChecked.length === 0) {
            return Swal.fire({
                title: "Nie wybrano żadnych płatności do zignorowania",
                icon: "info",
                showCloseButton: true,
                showConfirmButton: false,
                showCancelButton: false,
                focusConfirm: false,
                width: 900,
            });
        }

        var firstItemFound = paymentsChecked[0];
        var reportGuid = firstItemFound !== undefined ? firstItemFound["report_guid"] : null;
        var itemsIdentifiers = paymentsChecked.map(item => item["data_row_id"]);
        var payload = {
            rowsIds: itemsIdentifiers,
            reportGuid: reportGuid
        }
        return paymentsHelperMethods.showIgnoreAllPaymentsModal(payload);

    },
    unIgnoreAll(paymentsChecked) {

        if (paymentsChecked.length === 0) {
            return Swal.fire({
                title: "Nie wybrano żadnych płatności do przywrócenia",
                icon: "info",
                showCloseButton: true,
                showConfirmButton: false,
                showCancelButton: false,
                focusConfirm: false,
                width: 900,
            });
        }

        var firstItemFound = paymentsChecked[0];
        var reportGuid = firstItemFound !== undefined ? firstItemFound["report_guid"] : null;
        var itemsIdentifiers = paymentsChecked.map(item => item["data_row_id"]);
        var payload = {
            rowsIds: itemsIdentifiers,
            reportGuid: reportGuid
        }
        return paymentsHelperMethods.showUnIgnoreAllPaymentsModal(payload);
    },


    showIgnoreAllPaymentsModal(itemsToIgnorePayload) {
        return Swal.fire({
            title: "Ignorowanie płatności",
            text: "Czy na pewno chcesz zignorować wybrane płatności?",
            icon: "warning",
            showCloseButton: true,
            showConfirmButton: true,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonText: 'Tak',
            cancelButtonText: 'Nie',
            width: 900,
        }).then((proceed) => {
            if (proceed.isConfirmed) {
                return paymentsHelperMethods.ignorePayments(itemsToIgnorePayload);
            } else {
                return new Promise((resolve) => {
                    resolve({isConfirmed: false});
                });
            }
        });

    },

    ignorePayments(itemsToIgnorePayload) {
        const lazyLoaderModule = useLazyLoaderModule()
        const paymentsModule = usePaymentsManagerModule()
        lazyLoaderModule.setDisplayLazyLoader(true);
        lazyLoaderModule.setProgressBarMessage( "Ignorowanie płatności");
        return paymentsModule.httpIgnorePayments(itemsToIgnorePayload).then((response) => {
            apiRequestsHelper.handleResponseWithDialogs(response, true);
            return new Promise((resolve) => {
                resolve({
                    isConfirmed: true,
                    reloadList: true,
                    ...response
                });
            });
        }).catch((error) => {
            apiRequestsHelper.catchResponseError(error, "httpIgnorePayments");
            return new Promise((resolve) => {
                resolve({
                    isConfirmed: true,
                    reloadList: true
                });
            });
        });
    },
    showUnIgnoreAllPaymentsModal(itemsToUnIgnorePayload) {
        return Swal.fire({
            title: "Przywracanie płatności",
            text: "Czy na pewno chcesz zakończyc ignorowanie wybranych płatności?",
            icon: "warning",
            showCloseButton: true,
            showConfirmButton: true,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonText: 'Tak',
            cancelButtonText: 'Nie',
            width: 900,
        }).then((proceed) => {
            if (proceed.isConfirmed) {
                return paymentsHelperMethods.unIgnorePayments(itemsToUnIgnorePayload);
            } else {
                return new Promise((resolve) => {
                    resolve({isConfirmed: false});
                });
            }
        });
    },
    unIgnorePayments(itemsToUnIgnorePayload) {
        const lazyLoaderModule = useLazyLoaderModule()
        const paymentsModule = usePaymentsManagerModule()
        lazyLoaderModule.setDisplayLazyLoader(true);
        lazyLoaderModule.setProgressBarMessage( "Przywracanie płatności");
        return paymentsModule.httpUnIgnorePayments(itemsToUnIgnorePayload).then((response) => {
            apiRequestsHelper.handleResponseWithDialogs(response, true);
            return new Promise((resolve) => {
                resolve({
                    isConfirmed: true,
                    reloadList: true,
                    ...response
                });
            });
        }).catch((error) => {
            apiRequestsHelper.catchResponseError(error, "httpUnIgnorePayments");
            return new Promise((resolve) => {
                resolve({
                    isConfirmed: true,
                    reloadList: true
                });
            });

        });
    },

    getIgnoreDocumentActionClass(row) {
        var isVisible = row["czy_widoczny"];

        if (isVisible == null || isVisible === 0) {
            return "element-not-visible";
        } else {
            return "btn btn-danger table-actions-button edit-button";
        }
    },
    getUnIgnoreDocumentActionClass(row) {

        var isVisible = row["czy_widoczny"];
        if (isVisible == null || isVisible === 0) {
            return "btn btn-success table-actions-button edit-button";
        } else {
            return "element-not-visible";
        }
    },
    exportToFile(searchRequest, selectedFilters, currentPage, sortingDirection, sortingKey, paidStatus, targetOutputFileFormat) {
        const lazyLoaderModule = useLazyLoaderModule()
        const paymentsModule = usePaymentsManagerModule()
        lazyLoaderModule.setDisplayLazyLoader(true);
        lazyLoaderModule.setProgressBarMessage( "Eksportowanie listy płatności do pliku");

        const searchAndFilterRequest = {
            fields: null,
            search: searchRequest,
            filters: selectedFilters
        }
        var payload = {
            searchAndFilterRequest: searchAndFilterRequest,
            currentPage: currentPage,
            sortingDirection: sortingDirection,
            sortingKey: sortingKey,
            paidStatus: paidStatus,
            outputFileFormat: targetOutputFileFormat

        };

        var fileNamePrefix = "Płatności";
        if (paidStatus === "PAID") {
            fileNamePrefix = "Płatności_opłacone";
        } else if (paidStatus === "UNPAID") {
            fileNamePrefix = "Płatności_nieopłacone";
        } else if (paidStatus === "PROBLEMATIC") {
            fileNamePrefix = "Płatności_błędne";
        }

        paymentsModule.httpExportPaymentsDataToFile(payload).then((response) => {
            paymentsHelperMethods.parseFileResource(response, targetOutputFileFormat, fileNamePrefix);
            lazyLoaderModule.setDisplayLazyLoader(false);
            // show success dialog
            return Swal.fire({
                title: "Eksport zakończony",
                text: "Eksport danych zakończony sukcesem",
                icon: "success",
                confirmButtonColor: "#34c38f",
            });

        }).catch((error) => {
            return apiRequestsHelper.catchResponseError(error, "httpExportPaymentsDataToFile");
        });


    },

    exportDocumentItemsToFile(currentPaymentDocumentGuid, outputFileFormat, sendEmailToSupplier, askForEmail) {
        const lazyLoaderModule = useLazyLoaderModule()
        const paymentsModule = usePaymentsManagerModule()
        lazyLoaderModule.setDisplayLazyLoader(true);
        lazyLoaderModule.setProgressBarMessage( "Eksportowanie listy płatności do pliku");


        const payload = {
            paymentDocumentGuid: currentPaymentDocumentGuid,
            outputFileFormat: outputFileFormat
        }

        return paymentsModule.httpExportPaymentDocumentItemsToFile(payload).then((response) => {
            const lazyLoaderModule = useLazyLoaderModule()
            lazyLoaderModule.setDisplayLazyLoader(false);
            log.log("Csv file response:")
            log.log(response)
            if (response.status !== 200) {

                var responseMessage = response.data
                apiRequestsHelper.fireExceptionModal("Coś jest nie tak!", responseMessage, "warning")
                    .then(() => {
                            lazyLoaderModule.setDisplayLazyLoader(false);
                            lazyLoaderModule.setProgressBarMessage( "");
                        }
                    );

                return new Promise((resolve) => {
                    resolve({isConfirmed: false});
                });

            }

            if (sendEmailToSupplier) {
                return paymentsHelperMethods.sendEmailToSupplier(currentPaymentDocumentGuid, response, outputFileFormat, "Płatność_przelana_za_dokumenty", askForEmail);
            } else {
                return paymentsHelperMethods.parseFileResource(response, outputFileFormat, "Płatność_przelana_za_dokumenty");
            }


        }).catch((error) => {
            return apiRequestsHelper.catchResponseError(error, "httpExportPaymentDocumentItemsToFile");
        });
    },

    sendEmailToSupplier(currentPaymentDocumentGuid, fileResponse, fileOutputFormat, fileNamePrefix, askForEmail) {
        // inform user that export is successful and ask if he would like to send an e-mail with the file
        if (askForEmail) {
            return Swal.fire({
                title: "Eksport zakończony",
                text: "Eksport danych zakończony sukcesem. Czy chcesz wysłać plik na e-mail?",
                icon: "success",
                showCloseButton: true,
                showConfirmButton: true,
                showCancelButton: true,
                focusConfirm: false,
                confirmButtonText: 'Tak',
                cancelButtonText: 'Nie',
                width: 900,
                customClass: {
                    container: "swal-highest"
                },
            }).then((proceed) => {

                if (proceed.isConfirmed) {

                    return paymentsHelperMethods.openSendPaymentDocumentMailForm(currentPaymentDocumentGuid, fileResponse);
                } else {
                    return paymentsHelperMethods.parseFileResource(fileResponse, fileOutputFormat, fileNamePrefix).then(() => {
                        return new Promise((resolve) => {
                            resolve({isConfirmed: false});
                        });
                    });

                }


            });
        } else {
            return paymentsHelperMethods.openSendPaymentDocumentMailForm(currentPaymentDocumentGuid, fileResponse);
        }

    },

    openSendPaymentDocumentMailForm(currentPaymentDocumentGuid, fileResponse) {
        const lazyLoaderModule = useLazyLoaderModule()
        const paymentsModule = usePaymentsManagerModule()
        lazyLoaderModule.setDisplayLazyLoader(true);
        lazyLoaderModule.setProgressBarMessage( "Przygotowuję treść wiadomości...");
        const docDataPayload = {
            documentGuid: currentPaymentDocumentGuid
        }
        return paymentsModule.httpGetSupplierAndDrugstoreForPaymentDocumentByGuid(docDataPayload).then((response) => {
            if (response.status !== 200) {
                return apiRequestsHelper.handleResponseWithDialogs(response, true);
            }
            lazyLoaderModule.setDisplayLazyLoader(false);
            const paymentDocData = response.data.payload;

            const documentData = paymentDocData["document"];
            const drugstoreData = paymentDocData["drugstore"];
            const supplierData = paymentDocData["supplier"];
            const sendMailDialogTitle = "Wyślij listę pozycji dla dokumentu płatności: " + documentData["documentNumber"];
            const drugstoreName = drugstoreData != null ? drugstoreData["name"] + " [" + drugstoreData["drugstoreClientId"] + "]" : "";
            const mailSubject = "Płatność za dokumenty " + drugstoreName;
            const mailMessage = "Dzień dobry, \n W załączniku znajduje się lista dokumentów zakupu z apteki: " + drugstoreName + ", opłaconych w dniu " +
                paymentsHelperMethods.formatDatetimeToLocaleFormat(documentData["documentIssueDateTime"]) + " na sumaryczną kwotę: " + documentData["documentValue"] + " zł." +
                "\n\n Pozdrawiam, \n";

            const mailTo = supplierData != null ? supplierData["email"] : "";
            const mailAttachmentName = paymentsHelperMethods.getResourceFileNameFromHeader(fileResponse);

            return new Promise((resolve) => {
                resolve(
                    {
                        isConfirmed: true,
                        sendMailDialogTitle: sendMailDialogTitle,
                        mailMessage: mailMessage,
                        mailSubject: mailSubject,
                        mailTo: mailTo,
                        mailCc: "",
                        mailAttachmentName: mailAttachmentName,
                    }
                );
            });

        }).catch((error) => {
            return apiRequestsHelper.catchResponseError(error, "httpGetSupplierAndDrugstoreForPaymentDocumentByGuid");
        });


    },
    getFileNameToSave(fileType, fileNamePrefix) {
        // get current system millis
        const millis = new Date().getTime();
        //setting default file name
        return fileNamePrefix + "_export" + new Date().toLocaleDateString() + "_" + millis + "." + fileType;
    },

    getResourceFileNameFromHeader(response) {
        // Get the Content-Disposition header
        const contentDisposition = response.headers['content-disposition'];
        let filename = null;
        if (contentDisposition) {
            // 1. Trial to parse filename*=UTF-8'' (the most common situation)
            let matches = /filename\*=UTF-8''([^;]*)/.exec(contentDisposition);
            if (matches && matches[1]) {
                filename = decodeURIComponent(matches[1]);
            }
            // 2. The trial to parse (RFC 2047: =?UTF-8?Q?...)
            else {
                matches = /filename="?=\?UTF-8\?Q\?([^?]*)\?="?/i.exec(contentDisposition);
                if (matches && matches[1]) {
                    // In this format the characters are prefixed with =, np =C5.
                    // JS decodeURIComponent need %, np %C5.
                    // Additional spaces in Q-encoding are often like _, and we have to replace the with actual spaces
                    let messyString = matches[1].replace(/=/g, '%').replace(/_/g, ' ');
                    try {
                        filename = decodeURIComponent(messyString);
                    } catch (e) {
                        console.error("Błąd dekodowania nazwy pliku", e);
                        filename = matches[1]; // Fallbackfor encoded version
                    }
                }
                // 3. Ordinary fallback
                else {
                    matches = /filename="?([^"]*)"?/.exec(contentDisposition);
                    if (matches && matches[1]) {
                        filename = matches[1];
                    }
                }
            }
        }

        return filename;
    },

    parseFileResource(response, defaultFileType, defaultFileNamePrefix) {

        //determine the content type from the header or default to octect stream

        // Extract filename from header
        let filename = paymentsHelperMethods.getResourceFileNameFromHeader(response);
        if (filename === null) {
            filename = paymentsHelperMethods.getFileNameToSave(defaultFileType, defaultFileNamePrefix);
        }

        var octetStreamMime = 'application/octet-stream';
        var contentType = response.headers["content-type"] || octetStreamMime;
        var blob = new Blob([response.data], {type: contentType});
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
        return new Promise((resolve) => {
            resolve({isConfirmed: true});
        });

    },
};
